import { profitTone, marginTone } from "@/lib/profit";
import { formatCurrency } from "@/lib/format";

/**
 * Money cell showing amount + Kâr/Zarar/Sıfır label with consistent color.
 * Props: value, showLabel (default true)
 */
export function ProfitCell({ value, showLabel = true, testId }) {
  const { className, label } = profitTone(value);
  return (
    <span className="inline-flex items-center gap-2 justify-end" data-testid={testId}>
      <span className={`font-mono text-sm font-medium ${className}`}>{formatCurrency(value)}</span>
      {showLabel && <span className={`text-[10px] uppercase tracking-wider ${className}`}>· {label}</span>}
    </span>
  );
}

/**
 * Margin cell showing percent + Kâr/Düşük Marj/Zarar label.
 * Props: value (number|string percent), minMargin, testId
 */
export function MarginCell({ value, minMargin, testId }) {
  const { className, label } = marginTone(value, minMargin);
  const display = value == null ? "-" : `%${value}`;
  return (
    <span className="inline-flex items-center gap-2 justify-end" data-testid={testId}>
      <span className={`font-mono text-sm font-medium ${className}`}>{display}</span>
      <span className={`text-[10px] uppercase tracking-wider ${className}`}>· {label}</span>
    </span>
  );
}
